import Animation from './animation'
import * as d3 from 'd3-selection'

class EnteringAnimation extends Animation {

  constructor (options) {
    super(options)
  }

  match (serie) {
    return this.seriesChanged &&
           this.previous.series.data().indexOf(serie) === -1 // We didn't have this serie previously
  }

  animate (serie, enter, selection, merged, exit) {
    let self = this
    enter.selectAll('path.fill')
         .data(this._fillData(serie))
         .enter()
         .call(this._insertFills, merged)
         .selectAll('path.fill')
         .select(function (d) {
           d3.select(this).call(self._setFill, d.color)
           return this
         })

    let path = enter.selectAll('path.line')
                    .data([serie.points, serie.points])
                    .enter()
                    .append('path')
                    .attr('class', d => `line ${serie.color || ''}`)
                    .call(this._setStroke, serie.color)

    path.filter((d, i) => i > 0)
        .style('opacity', serie.opacity)
    path.filter((d, i) => i == 0)
        .classed('outer-line', true) // Visual UI helper

    let duration = serie.fill ? (this.timing.duration / 2) : this.timing.duration

    enter.transition()
         .duration(duration)
         .selectAll('path.line')
         .tween('grow', () => this._getLineInterpolater(serie, path))
         .end().then(() => {
           // Now show the fill
           enter.transition()
                .duration(duration)
                .call(this._growFills)
         })
  }

}

export default EnteringAnimation
